module.exports = __webpack_public_path__ + "static/media/paredes_vivas_4.50b67393.jpg";